import { ReactElement } from 'react'
import { Route, Routes } from 'react-router-dom'
import { LoginScreen } from '../../screens/public/login-screen'
import { useRecoilValue } from 'recoil'
import { RegisterScreen } from '../../screens/public/register-screen'
import AuthorizedRoot from '../../screens/authorized/authorized-root'
import { loggedUserState } from '../../states/logged-user-state'

export const NavigationContainer = (): ReactElement => {
  const user = useRecoilValue(loggedUserState)

  if (!user) {
    return (
      <Routes>
        <Route path="/">
          <Route index element={<LoginScreen />} />
          <Route path="/sign-up" element={<RegisterScreen />} />
          <Route path="*" element={<LoginScreen />} />
        </Route>
      </Routes>
    )
  }

  return (
    <Routes>
      <Route path="*" element={<AuthorizedRoot />} />
    </Routes>
  )
}